import { Component, OnInit } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd';
import { WhatIsPaycellComponent } from '../../shared/notification/what-is-paycell/what-is-paycell.component';

@Component({
  selector: 'pa-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private modalService: NzModalService) {
  }

  tplModal: NzModalRef;

  ngOnInit(): void {
  }

  createTplModal(): void {
    this.tplModal = this.modalService.create({
      nzContent: WhatIsPaycellComponent,
      nzMaskClosable: true,
      nzClosable: true,
      nzFooter: null,
      nzStyle: {width: '513px', height: '589px', 'border-radius': '15px',  'box-shadow': '0 0 15px 0 rgba(0, 0, 0, 0.25)', 'background-color': '#ffffff'}
    });
  }
}
